import type { AllocationBE, AssetTransactionTypeEnum, IAssetTransaction } from '@talos/kyoko';
import { baseRestApi, createTag } from '../../../utils/rtkQuery/baseRestApi';

export interface CreateAssetTransactionItem {
  TransactionID: string;
  TransactTime: string;
  Type: AssetTransactionTypeEnum;
  MarketAccount: string;
  Asset: string;
  Amount: string;
  SubAccount?: string;
  Allocation?: AllocationBE;
  AllocationStatus?: 'Manual' | 'Unallocated';
}

const assetTransactionsApiInternal = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    createAssetTransaction: builder.mutation<IAssetTransaction[], CreateAssetTransactionItem[]>({
      query: body => ({
        method: 'POST',
        url: '/asset-transactions',
        body,
        headers: { 'Content-Type': 'application/json' },
      }),
      invalidatesTags: () => [createTag('AssetTransaction', 'LIST')],
    }),
  }),
});

export const { useCreateAssetTransactionMutation } = assetTransactionsApiInternal;
